<div>
    <app-settlement-detail-title
            [sectionTitle]="'Settlement Information'"
            class="settlement-info-title">
    </app-settlement-detail-title>

    <div class="settlement-info-fields">
        <div class="material-info-fields">
            <app-input-dropdown
                    [initialValue]="$safeNavigationMigration(configuration?.materialDetail) | prettyPrintMaterialNumber | undefinedValue"
                    [showViewMode]="true"
                    baseCypressTag="settlement-form-material"
                    label="Part NO. / Part description">
            </app-input-dropdown>
        </div>
        <div class="supplier-info-fields">
            <app-input-dropdown
                    [initialValue]="$safeNavigationMigration(configuration?.supplierDetail) | prettyPrintReference | undefinedValue"
                    [showViewMode]="true"
                    baseCypressTag="settlement-form-supplier"
                    label="Supplier">
            </app-input-dropdown>
        </div>
    </div>

    <div class="complaint-detail-form-table">
        <app-input-textarea [height]="88"
                            [initialValue]="$safeNavigationMigration(configuration?.complaintDetail) | undefinedValue"
                            [maxLength]="400"
                            [showViewMode]="true"
                            baseCypressTag="complaint-form-description"
                            label="Complaint description">
        </app-input-textarea>
    </div>
</div>

<div class="settlement-timeline-wrapper">
    <app-status-timeline [configuration]="mapStatusTimelineToConfigurationModel()"></app-status-timeline>
</div>

